import { render, staticRenderFns } from "./DeclineHandover.vue?vue&type=template&id=c2ab9314&"
import script from "./DeclineHandover.vue?vue&type=script&lang=js&"
export * from "./DeclineHandover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports